import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

function SidebarDropdown({ label, children }) {
    const [open, setOpen] = useState(false);

    return (
        <div className="border-b border-white/20">
            {/* Header principal */}
            <div
                className="py-4 flex justify-between items-center cursor-pointer select-none"
                onClick={() => setOpen(!open)}
            >
                <span>{label}</span>
                <FontAwesomeIcon
                    icon={open ? faChevronUp : faChevronDown}
                    className="text-[14px]"
                />
            </div>

            {/* Submenú animado */}
            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.25 }}
                        className="overflow-hidden"
                    >
                        <div className="pl-4">
                            {children}
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}

export default SidebarDropdown;
